export default __webpack_public_path__ + "static/virtus-5c3a221ce6b3fdf45e48a4d382291271.pdf";